import { AxiosResponse } from "axios";
import client from "../client";
import { getApplicationInfoConfig } from "./GetApplicationInfoConfig";
import { GetApplicationinfoResponse } from "./types";

const getApplicationInfo = ({
  applicationId,
}: {
  applicationId: string;
}): Promise<AxiosResponse<GetApplicationinfoResponse>> =>
  client({ ...getApplicationInfoConfig(applicationId) });

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getApplicationInfo,
};
